exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cube-swipe{overflow:hidden}.cube-swipe-enter-active,.cube-swipe-enter-active .cube-swipe-item-inner,.cube-swipe-leave-active,.cube-swipe-leave-active .cube-swipe-item-inner{-webkit-transition:all .3s;transition:all .3s}.cube-swipe-enter .cube-swipe-item-inner,.cube-swipe-leave-to .cube-swipe-item-inner{height:0}", ""]);

// exports
